export const DEVICE_TYPE = {
  mobile: 'mobile',
  desktop: 'desktop',
};

export const isMobileDevice = (userAgent = navigator.userAgent) => /Mobile/i.test(userAgent);

export const getDeviceType = () => (isMobileDevice() ? DEVICE_TYPE.mobile : DEVICE_TYPE.desktop);

export const IS_MAC_OS = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
